export default __webpack_public_path__ + "static/media/podcast--2.dfd567cd.jpg";